package one.healthium.healthKit.ui

import androidx.compose.runtime.Composable

typealias ConnectFlowController = () -> Unit

enum class ConnectFlowAction {
    CONNECT,
    MANAGE,
}

@Composable
expect fun ConnectFlowContainer(action: ConnectFlowAction, content: @Composable (ConnectFlowController) -> Unit,)
